import { render } from "./ProgramAddInformation.vue?vue&type=template&id=1d698d47&scoped=true&ts=true"
import script from "./ProgramAddInformation.vue?vue&type=script&lang=ts"
export * from "./ProgramAddInformation.vue?vue&type=script&lang=ts"

import "./ProgramAddInformation.vue?vue&type=style&index=0&id=1d698d47&scoped=true&lang=css"

import exportComponent from "C:\\Ventla new admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d698d47"]])

export default __exports__